module.exports = __webpack_public_path__ + "static/media/Backlog.b1d4ad39.png";